import React from 'react';

export default React.memo(function HorizontalLine() {
    return ( 
        <hr />
    );
})